import { Link, useNavigate } from "react-router-dom";
import ContentPage from "../../Content";
import Swal from "sweetalert2";
import axios from "axios";
import BaseUrl from "../../../utils/BaseUrl";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../utils/User_check";
import can from "../../../utils/Can";

const url = BaseUrl();
function OthersPage(){

  const [errorPass,setErrorPass] = useState('');
  const [errors,setErrorM] = useState({});
  const [errorPassEg,setErrorPassEg] = useState('');
  const [changePass,setChangePass] = useState({
      'cfmPass':'',
      'newPass':'',
      'oldPass':''
  });
  const [loading,setLoading] = useState(false);


  const {user,role, permissions} = useContext(UserContext);
  const navigate = useNavigate();
  useEffect(()=>{
    // if(user && permissions && !can(permissions,'VENTE MOMO COMMERCIAUX')){
    //     navigate('/page-no-found');
    // }
  },[user]);


  
  const submitChangePass=(e)=>{
    e.preventDefault();
    setErrorPassEg('');
    setErrorPass('');
    if(changePass.oldPass !== '' && changePass.newPass !== '' && changePass.cfmPass !== ''){
      
      const _formData = new FormData();
      _formData.append('password',changePass.oldPass);
      _formData.append('password_new',changePass.newPass);

      if(changePass.newPass == changePass.cfmPass){
        setLoading(true);
        try {
          axios.post(url.base+'/update-password/',_formData,{
            headers:{
                'Content-Type':'multipart/form-data',
                "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                
            },
            //  credentials:'include'
        }).then((resp)=>{
             if(resp.data.status == 200){
                Swal.fire({
                  position: 'top-end',
                  icon: 'success',
                  title: resp.data.message,
                  showConfirmButton: false,
                  timer: 3000,
                  toast:true,
                  position:'top-right',
                  timerProgressBar:true
                });

                setChangePass({
                    'cfmPass':'',
                    'newPass':'',
                    'oldPass':''
                })
                window.$("#exampleModalFiltre").modal('hide');
                setLoading(false);
             }else{
              setErrorPass(resp.data.message);
              setLoading(false)
             }
          })
        } catch (error) {
          console.log(error);
        }
      }else{
        setErrorPassEg('Le nouveau mot de passe ne correspond pas');
      }
      
    }else{
      setErrorPassEg('Veuillez renseignre votre nouveau mot de passe');
  }

  }

  const handleChangePass = (event)=>{
    setChangePass({
      ...changePass,
      [event.target.name]:event.target.value
    })
  }

  const open_filtre_template_modal=()=> {
    window.$("#exampleModalFiltre").modal('show');
  }
    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
            <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pr-3">Paramètres</p>
                  </a>
                  <a class="pl-3 mr-4" href="#">
                    <p class="m-0">Autres paramètres</p>
                  </a>
                </div>
                {/* <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text">
                  <i class="mdi mdi-plus-circle"></i> Add Prodcut </button> */}
              </div>
              {/* <div class="header-left">
                <Link class="btn btn-primary mb-2 mb-md-0 mr-2" to="/parametres/add-distributeur"> Ajouter un distributeur</Link>
                <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button>
              </div> */}
              
            </div>

            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">PARAMETRAGES</h4>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>DESIGNATION</th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th className="text-center">ACTIONS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* <tr>
                            
                            <td className="fw-bold">Distributeurs</td>
                            <td class="py-1"></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-center">
                                <Link class="btn btn-primary" to="/parametres/distributeurs"> Acceder </Link>
                            </td>

                          </tr> */}
                      {user && permissions && can(permissions,'LISTE DES UTILISATEURS') &&
                          <tr>                                
                              <td className="fw-bold">Utilisateurs</td>
                              <td class="py-1"></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td className="text-center">
                              <Link class="btn btn-primary" to="/parametres/users"> Acceder </Link>
                              </td>
                        </tr>
                      }
                          
                          {user && permissions && can(permissions,'LISTE DES ROLES ET PERMISSIONS') &&
                            <>
                                <tr>
                                    
                                    <td className="fw-bold">Rôles</td>
                                    <td class="py-1"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-center">
                                    <Link class="btn btn-primary" to="/parametres/roles"> Acceder </Link>
                                    </td>

                                  </tr>

                                  <tr>
                                    
                                    <td className="fw-bold">Groupe Permissions</td>
                                    <td class="py-1"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-center">
                                    <Link class="btn btn-primary" to="/groups-permission"> Acceder </Link>
                                    </td>

                                  </tr> 


                                  <tr>
                                    
                                    <td className="fw-bold">Permissions</td>
                                    <td class="py-1"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-center">
                                    <Link class="btn btn-primary" to="/parametres/permissions"> Acceder </Link>
                                    </td>

                                  </tr> 
                            </>
                          }
                           {user && permissions && can(permissions,'ACCES UTILISATEURS') &&
                            <tr>
                              
                              <td className="fw-bold">Accès Utilisateurs</td>
                              <td class="py-1"></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td className="text-center">
                              <Link class="btn btn-primary" to="/access-utilisateurs"> Acceder </Link>
                              </td>

                            </tr>
                          }
                          <tr>
                            
                            <td className="fw-bold">Mot de passe</td>
                            <td class="py-1"></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-center">
                            <button class="btn btn-primary" onClick={()=>open_filtre_template_modal()}> Modifier </button>
                            </td>

                          </tr>
                         
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal fade" id="exampleModalFiltre"  tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-md" role="document">
                        <form class="modal-content" onSubmit={submitChangePass}>
                            <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalCenterTitle">Modifier votre mot de passe</h5>
                            <button type="button" class="btn-close" onClick={()=>window.$("#exampleModalFiltre").modal('hide')}>
                            </button>
                            </div>
                            <div class="modal-body">
                                <div className="row">
                                    <div class="mb-3 col-md-12">
                                    <label className="form-label">Ancien mot de passe</label>
                                    <input type="password" className="form-control" name="oldPass" onChange={handleChangePass} value={changePass.oldPass}/>
                                        {errorPass !=='' && <span className="text-danger">{errorPass}</span>}
                                    </div>  
                                    <div class="mb-3 col-md-12">
                                        <label className="form-label">Nouveau mot de passe</label>
                                        
                                        <div className="input-group">
                                            <input className="form-control fakepassword" type="password" id="psw-input" name="newPass"  onChange={handleChangePass} value={changePass.newPass} />
                                          
                                        </div>
                            
                                    </div> 
                                    <div class="mb-3 col-md-12">
                                    <label className="form-label">Confirmer votre mot de passe</label>
                                    <input type="password" className="form-control" placeholder="" name="cfmPass" onChange={handleChangePass} value={changePass.cfmPass}/>
                                    {errorPassEg !=='' &&  <span className="text-danger">{errorPassEg}</span>}
                            
                                    </div> 
                                </div> 
                                    
                            </div>
                            <div class="modal-footer">
                            {!loading && <button type="submit" class="btn btn-primary" >Enregistrer la modification</button>}
                                {loading && 
                                <button type="button" class= "btn btn-primary disabled form-control">Chargement en cours  <div class="text-center">
                                  <div class="spinner-border p-2" role="status">
                                  </div>
                                </div>
                                </button> 
                                }
                            </div>
                        </form>
                    </div>
            </div>
            </ContentPage>
        </>
    )
}

export default OthersPage;